/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_All_PaymentsInputs */

const en_admin_payments_all_payments = /** @type {(inputs: Admin_Payments_All_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Payments`)
};

const zh_admin_payments_all_payments = /** @type {(inputs: Admin_Payments_All_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有支付`)
};

/**
* | output |
* | --- |
* | "All Payments" |
*
* @param {Admin_Payments_All_PaymentsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_all_payments = /** @type {((inputs?: Admin_Payments_All_PaymentsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_All_PaymentsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_all_payments(inputs)
	return zh_admin_payments_all_payments(inputs)
});
export { admin_payments_all_payments as "admin.payments.all_payments" }